import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  border: 1px solid #e3e4e6;
  border-radius: 10px;
  transition: ease 0.4s;
  cursor: pointer;
  transition: ease 0.4s;
  width: 100%;

  &:hover {
    border: 1px solid #f7941d;
  }

  @media (max-width: 1024px) {
    &.active {
      display: flex;
      border: 1px solid #f7941d;
    }
  }
`;

export const Top = styled.div`
  position: relative;
  background: #e6e6e6;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  padding: 16px 32px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  @media (max-width: 1024px) {
    padding: 12px 16px;
  }
`;

export const Bottom = styled.div`
  background: transparent;
`;

export const BottomWrapper = styled(Top)`
  background: transparent;
  transition: ease 0.4s;

  @media (max-width: 1024px) {
    display: none;

    &.active {
      display: flex;
    }
  }
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 160px;

  &.wide {
    max-width: 320px;
  }

  @media (max-width: 1024px) {
    max-width: 140px;
  }
`;

export const BlockCell = styled(Cell)`
  max-width: 1920px;
  padding: 16px 32px 0px;

  @media (max-width: 1024px) {
    padding: 16px 16px 0px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
`;

export const Text = styled.p`
  font-size: 14px;
  color: #2c2c2c;

  span {
    font-weight: 700;
  }

  &.big {
    font-size: 18px;
    font-weight: 700;
  }

  &.small {
    font-size: 11px;
    font-weight: 600;
  }

  @media (max-width: 1024px) {
    font-size: 12px;

    &.big {
      font-size: 14px;
    }
  }
`;

export const ArrowDownMobile = styled.img`
  display: none;
  position: absolute;
  right: 15px;
  top: 15px;
  transition: ease 0.4s;

  @media (max-width: 1024px) {
    display: block;

    &.active {
      transform: rotate(180deg);
    }
  }
`;

export const ButtonMobile = styled.button`
  display: none;
  background: transparent;
  border-radius: 80px;
  border: 1px solid #f7941d;
  color: #f7941d;
  padding: 15px;
  margin: 0 0 16px;
  text-align: center;
  @media (max-width: 600px) {
    width: calc(100% - 30px);
  }
  @media (min-width: 601px) {
    width: 200px;
  }
  @media (max-width: 1024px) {
    &.active {
      display: block;
    }
  }
`;

export const LinkMobile = styled.a`
  width: 100%;
`;

export const LinkDesktop = styled(LinkMobile)`
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;

  @media (max-width: 1024px) {
    display: none;
  }
`;
